
export const brandName = 'REAL<span class="text-orange-500">RISES</span>';
export const brandNamePlain = 'RealRises';
export const heroTitle = '利用房地产股权投资Bitcoin & Tech Equity';
export const heroSubtitle1 = '无需首付，无月供，无利息。';
export const heroSubtitle2 = '5年期限，可随时提前结束。';
export const heroDescription = `RealRises用<span class="italic">我们的</span>资金购买Bitcoin & Tech Equity——您无需支付。价格上涨您获得<strong>一半收益</strong>。下跌时您<strong>承担损失</strong>，以房地产股权担保。`;
export const heroFootnote = '* 随时退出<strong>无罚金</strong>';
export const navigation = {
  howItWorks: '运作方式',
  calculator: '计算器',
  faq: '常见问题',
  aboutUs: '关于我们',
  getStarted: '开始使用'
};
export const introduction = {
  line1: 'REALRISES',
  line2: 'BITCOIN & TECH EQUITY 合作伙伴'
};
export const example = {
  title: '快速示例',
  subtitle: 'RealRises BTIP 三步骤',
  disclaimer: '示例忽略2%成交费用 + 第三方费用。计算器<strong>包含</strong>这些成本。'
};
export const footer = {
  copyright: '© 2025 RealRises by HomeHODL LLC。保留所有权利。',
  privacyPolicy: '隐私政策',
  termsOfService: '服务条款',
  disclaimer: 'RealRises不是放贷机构或投资顾问。所有说明均为假设性。产品条款可能变更。非个人投资建议。',
  riskWarning: '投资涉及损失风险，包括止赎风险。仅用于商业/投资目的。',
  agreement: '使用本网站即表示同意我们的条款和隐私政策。',
  madeWith: '使用'
};

export const faq = {
  title: '常见问题',
  subtitle: '关于RealRises Bitcoin & Tech Equity合作伙伴关系的常见问题',
  q1: 'RealRises如何运作？',
  a1: '我们用自己的资本购买Bitcoin & Tech Equity——您无需预付费用。结束时，您获得50%收益。如果下跌，您承担损失（由房屋净值担保）。',
  q2: '费用是多少？',
  a2: '无预付费用或月供。成交时：2%合作费用加3千-5千美元第三方费用。可滚入现有抵押贷款。',
  q3: '可以提前退出吗？',
  a3: '是的，随时退出无罚金。完全灵活。',
  q4: '如果Bitcoin & Tech Equity下跌怎么办？',
  a4: '您承担损失，由房屋净值担保。主要住所不会因合作损失被止赎。',
  q5: '可以获得多少敞口？',
  a5: '通常5万-50万美元，基于您的房屋净值和我们的风险评估。使用计算器估算。',
  q6: '要求是什么？',
  a6: '拥有具有足够净值的美国房地产。我们评估信用、收入、债务比率和房产价值。',
  q7: '这是贷款吗？',
  a7: '不，这是投资合作伙伴关系。我们共同承担风险和回报。无月供或利息。',
  q8: '哪些州可用？',
  a8: '在大多数美国州可用。请联系我们确认您所在地区的可用性。',
  stillHaveQuestions: '有问题？我们在这里帮助您。'
};

export const about = {
  ourMission: {
    title: '我们的使命',
    description: '通过利用房主的房地产股权，民主化Bitcoin和科技股权投资的机会。我们相信每个人都应该有机会参与数字经济，而无需传统的大额资本要求障碍。'
  },
  ourValues: {
    title: '我们的价值观',
    transparency: {
      title: '透明度',
      description: '清晰的条款，无隐藏费用，建立在信任和开放沟通基础上的直接合作伙伴关系。'
    },
    innovation: {
      title: '创新',
      description: '开创连接传统房地产财富与新兴数字资产的新金融产品。'
    },
    partnership: {
      title: '合作伙伴关系',
      description: '真正的合作伙伴关系，我们共同承担风险和回报，使我们的利益与您保持一致。'
    }
  },
  ourLeadership: {
    title: '我们的领导团队',
    ariel: {
      title: '联合创始人兼首席执行官',
      description: '在金融科技和房地产领域拥有丰富经验的远见卓识的领导者。Ariel推动RealRises的战略方向和另类投资解决方案的创新。'
    },
    kysen: {
      title: '联合创始人兼首席运营官',
      description: '专注于扩展合作伙伴关系和确保无缝客户体验的运营专家。Kysen监督日常运营和业务发展。'
    }
  }
};

export default {
  brandName,
  brandNamePlain,
  heroTitle,
  heroSubtitle1,
  heroSubtitle2,
  heroDescription,
  heroFootnote,
  navigation,
  introduction,
  example,
  footer,
  faq,
  about
};
